import { call, put, select, takeLeading } from 'redux-saga/effects';

import logger from '@elab/core/utils/logger';
import { selectors as userSelectors } from '@elab/core/store/user';
import { selectors as configSelectors } from '@elab/core/store/config';
import { selectors as productSelectors } from '@elab/core/store/product';

import { addToNotifyMeListStrategies } from './strategies';

import analytics from '../../utils/analytics';
import api from './api';

import { actions, types } from '.';

export function* loadNotifyMeList() {
    yield put(actions.setLoading(true));
    const isAnonymous = yield select(userSelectors.isAnonymous);

    try {
        if (!isAnonymous) {
            const response = yield call(api.loadNotifyMeList);
            yield put(actions.setNotifyMeList(response));
        }
    } catch (e) {
        yield call(logger.error, e);
    } finally {
        yield put(actions.setLoading(false));
    }
}

export function* addToNotifyMeListWithAuthCheck({ payload }) {
    yield put(actions.setLoading(true));
    const isAnonymous = yield select(userSelectors.isAnonymous);
    const strategies = yield select(configSelectors.getAddToNotifyMeListStrategies);
    const productData = yield select(productSelectors.getProduct);

    try {
        isAnonymous
            ? yield call(addToNotifyMeListStrategies[strategies.guest], payload.code)
            : yield call(addToNotifyMeListStrategies[strategies.loggedInUser], payload.code);

        if (productData.details.code === payload.code) {
            yield call(analytics.handleNotifyMeClick, productData.details);
        }
    } catch (e) {
        yield call(logger.error, e);
    } finally {
        yield put(actions.setLoading(false));
    }
}

export function* removeFromNotifyMeList({ payload }) {
    yield put(actions.setLoading(true));
    const { code } = payload;
    const isAnonymous = yield select(userSelectors.isAnonymous);

    try {
        if (!isAnonymous) {
            yield call(api.removeFromNotifyMeList, code);
        }
    } catch (e) {
        yield call(logger.error, e);
    } finally {
        yield put(actions.setLoading(false));
    }
}

export default [
    takeLeading(types.LOAD_NOTIFY_ME_LIST, loadNotifyMeList),
    takeLeading(types.ADD_TO_NOTIFY_ME_LIST, addToNotifyMeListWithAuthCheck),
    takeLeading(types.REMOVE_FROM_NOTIFY_ME_LIST, removeFromNotifyMeList),
];
